<template>
    <v-autocomplete
        label="Město"
        v-model="city"
        :items="cities"
        :loading="isCitySearching"
        :search-input.sync="searchCity"
        item-text="label"
        item-value="id"
        hide-no-data
        return-object
        required
        dark
    ></v-autocomplete>
</template>

<script>
    import { SUGGEST_REQUEST } from '../../store/actions/city';

    export default {
        name: 'SuggestCity',
        props: {
            prefill: {
                type: Object,
                required: false,
            },
        },
        data () {
            return {
                city: null,
                searchCity: '',
                cities: [],
                isCitySearching: false,
                lastSearchTerm: '',
            };
        },
        mounted () {
            if (this.prefill) {
                this.city = this.prefill;
                this.searchCity = this.prefill.label;
            }
        },
        watch: {
            searchCity (term) {
                setTimeout(async () => {
                    if (term === null || term === undefined || term.length < 2 || this.lastSearchTerm === term) {
                        return;
                    }
                    this.cities = await this.$store.dispatch('city/' + SUGGEST_REQUEST, { term });
                }, 200);
            },
            city (city) {
                this.$emit('input', city);
            },
        },
    }
</script>

